/// ページトップ
import SmoothScroll from 'smooth-scroll';

/**
 * ページトップクリック時動作
 */
const pageTopScrl = () => {
    const pageTop = document.querySelector('.s-pagetop a');
    const scrl = new SmoothScroll();
    if (!pageTop) return;

    pageTop.addEventListener('click', (event) => {
        event.preventDefault();

        scrl.animateScroll(0);

        return false;
    });
};

/**
 * ページトップ 画面下部固定
 */
const fixedBottom = () => {
    const pageTop = document.querySelector('.s-pagetop');
    const footer = document.querySelector('.l-footer');
    const className = `fixed`;

    if (!pageTop || !footer) return false;

    const frect = footer.getBoundingClientRect();
    // フッターのY座標
    const fBottom = frect.top + window.pageYOffset;
    // ブラウザ下部のY座標
    const winBottom = window.pageYOffset + window.innerHeight;

    if (fBottom < winBottom && !pageTop.classList.contains(className)) {
        pageTop.classList.add(className);
    } else if (fBottom >= winBottom && pageTop.classList.contains(className)) {
        pageTop.classList.remove(className);
    }
};

/**
 * ページトップ 出る出ないの調整
 */
const toggle = () => {
    const pageTop = document.querySelector('.s-pagetop');
    const main = document.querySelector('.l-global');
    const className = 'show';

    if (!pageTop || !main) return false;

    const mrect = main.getBoundingClientRect();
    const mTop = mrect.top + window.pageYOffset;
    
    if (mTop < window.pageYOffset && !pageTop.classList.contains(className)) {
        pageTop.classList.add(className);
    } else if (mTop >= window.pageYOffset && pageTop.classList.contains(className)) {
        pageTop.classList.remove(className);
    }
};

window.addEventListener('DOMContentLoaded', pageTopScrl, false);
window.addEventListener('DOMContentLoaded', fixedBottom, false);
window.addEventListener('DOMContentLoaded', toggle, false);
window.addEventListener('scroll', fixedBottom, false);
window.addEventListener('scroll', toggle, false);


// WEBPACK FOOTER //
// ./js/modules/pagetop.js